import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { t } from '../../../modules/infra/i18n';
import PromoValue from '../../main/settings/promoCodes/components/PromoValue';
import EditableText from './EditableText';
import EmailPreview from './EmailPreview';
import Date from '../../common/date';
import { subjectInputId } from '../constants';

const PromoEmailPreview = ({
  backgroundImage,
  color,
  logo,
  message,
  onMessageChange,
  onSubjectChange,
  shopAddress,
  shopName,
  subject,
  promo,
  editable,
  onSubjectClick,
}) => (
  <EmailPreview
    {...{
      backgroundImage,
      color,
      logo,
      shopAddress,
      shopName,
      editable,
      onSubjectChange,
      subject,
      onSubjectClick,
    }}
  >
    <div className="beta u-mb- u-type--normal">
      <EditableText
        defaultText={t('engage:email_preview.click_to_edit')}
        value={subject}
        onChange={onSubjectChange}
        editable={editable}
        id={subjectInputId}
      />
    </div>
    <EditableText value={message} onChange={onMessageChange} editable={editable} />
    <div
      display-if={promo && !isEmpty(promo)}
      className="c-panel c-panel--flat c-panel--small-radius u-ph u-pt- u-pb+ u-mt u-type--normal"
      style={{ color: '#fff', backgroundColor: color }}
    >
      <div className="u-type--bold alpha u-pt-">
        <PromoValue promoCode={promo} />
      </div>
      <div className="u-type--bold u-mt- u-pt--">
        {t('engage:promo.get_off_message_start')} <PromoValue promoCode={promo} />{' '}
        {t('engage:promo.get_off_message_end')}
      </div>
      <div className="u-mt- u-pt-- u-pb-">
        {t('engage:email_preview.book_appointment')}{' '}
        <span display-if={promo.expirationDate}>
          {t('engage:promo.by')}{' '}
          <b>
            <Date timezone="UTC">{promo.expirationDate}</Date>
          </b>
        </span>{' '}
        {t('engage:promo.and_get')}{' '}
        <b>
          <PromoValue promoCode={promo} />
        </b>{' '}
        {t('engage:promo.off_using_code')} <b className="u-type--uppercase">{promo.code}</b>.
      </div>
      <div className="c-email-preview__cta u-mt" style={{ color }}>
        {t('engage:email_preview.book_appointment')}
      </div>
    </div>
  </EmailPreview>
);
PromoEmailPreview.propTypes = {
  message: PropTypes.string,
  onMessageChange: PropTypes.func.isRequired,
  onSubjectChange: PropTypes.func.isRequired,
  onSubjectClick: PropTypes.func.isRequired,
  shopAddress: PropTypes.shape({
    street: PropTypes.string,
    street2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
  shopName: PropTypes.string.isRequired,
  subject: PropTypes.string,
  backgroundImage: PropTypes.string,
  color: PropTypes.string,
  logo: PropTypes.string,
  promo: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
    expirationDate: PropTypes.string,
  }),
  editable: PropTypes.bool,
};
PromoEmailPreview.defaultProps = {
  message: '',
  subject: '',
  backgroundImage: '',
  color: '#4d4d4d',
  logo: '',
  promo: {},
  editable: true,
};

export default PromoEmailPreview;
